import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";

import { ErrorSnacktOpen } from "../../ErrorSnack/actions";

export const OpenCargarBorrador = (aceptaGuardadoModalEdicion) => ({
  type: "OPEN_CARGAR_BORRADOR_EDITAR_PRESTACION",
  aceptaGuardadoModalEdicion,
});

export const ConfirmacionGuardadoEdicion = (aceptaGuardadoModal) => ({
  type: "CONFIRMACION_GUARDADO_EDICION",
  aceptaGuardadoModal,
});

export const CargarDetallePrestacion = (detallePrestacion) => ({
  type: "CARGAR_DETALLE_PRESTACION",
  detallePrestacion,
});

export const CambiarVigenciaPrestacionEdicion = (vigenciaPrestacionEdicion, error) => ({
  type: "CAMBIAR_VIGENCIA_PRESTACION_EDICION",
  vigenciaPrestacionEdicion,
  error,
});

export const CargarCentrosAtencionPrestacion = (detalleCentros) => ({
  type: "CARGAR_CENTROS_PRESTACION",
  detalleCentros,
});

export const OpenConfirmacionGuardadoEdicion = () => (dispatch) => {
  dispatch(OpenCargarBorrador(true));
};

export const CambiarMontoArancelPrestacion = (montoArancelPrestacion) => ({
  type: "EDIT_PRESTACION/CAMBIAR_MONTO_ARANCEL_PRESTACION",
  montoArancelPrestacion,
});

export const CambiarMontoArancelError = (errorArancelPrestacion) => ({
  type: "EDIT_PRESTACION/CAMBIAR_MONTO_ARANCEL_ERROR",
  errorArancelPrestacion,

});

export const CloseConfirmacionGuardadoEdicion = () => (dispatch) => {
  dispatch(OpenCargarBorrador(false));
};

export const CambiarValorPres = (valorPrestacion) => ({
  type: "CAMBIAR_VALOR_PRES",
  valorPrestacion,
});

export const cargarCaracteristicasMod = (caracteristicas) => ({
  type: "CARGAR_CARACTERISTICAS_MOD",
  caracteristicas,
});

export const GuardarArbolInicialMod = (tiposArancelPrestacion, centrosAtencionPrestacion) => ({
  type: "GUARDAR_ARBOL_INICIAL_MOD",
  tiposArancelPrestacion,
  centrosAtencionPrestacion,
});

export const GuardarValorArancelMod = (valor, id) => ({
  type: "GUARDAR_VALOR_ARANCEL_MOD",
  valor,
  id,
});

export const GuardarValorPrestacionesMod = (value, id, error, rutArancel, centroAtencion) => ({
  type: "GUARDAR_VALOR_PRESTACIONES_MOD",
  value,
  id,
  error,
  rutArancel,
  centroAtencion,
});

export const CambiarMontoArancelErrorMod = (valor, id) => ({
  type: "GUARDAR_VALOR_PRESTACIONES_MOD_ERR",
  valor,
  id,
});

export const CambiarUnidadGrillaMod = (value, id, error, rutArancel, centroAtencion) => ({
  type: "CAMBIAR_UNIDAD_GRILLA_MOD",
  value,
  id,
  error,
  rutArancel,
  centroAtencion,
});

export const CambiarUnidadReplicar = (tipoUnidad) => ({
  type: "CAMBIAR_UNIDAD_REPLICAR_MOD",
  tipoUnidad,
});

export const cargarValorMaxPrestacion = (valorMaxPres) => ({
  type: "CARGAR_VALOR_MAX_PRES_MOD",
  valorMaxPres,
});

export const CambiarCheckRowsMod = (checked, id, rutArancel, centroAtencion) => ({
  type: "CHECK_ROWS_MOD",
  checked,
  id,
  rutArancel,
  centroAtencion,
});

export const CambiarCheckRowsModArancel = (checked, arancel) => ({
  type: "CHECK_ROWS_MOD_ARANCEL",
  checked,
  arancel
})

export const LimpiarErroresGrillaMod = () => ({
  type: "EDITAR_PREST/LIMPIAR_ERROR_GRILLA_UNSELECT",
});

export const DisplayEditErrorText = (Errors) => ({
  type: "EDIT_PREST/DISPLAY_ERROR_TEXT",
  Errors,
});

export const LoadingArbolDetalle = (load) => ({
  type: "EDIT_PREST/LOADING_ARBOL_DETALLE",
  load,
});

export const ShowDupsMsg = (dupsMsg) => ({
  type: "EDIT_PREST/SHOW_DUPS_MSG",
  dupsMsg,
});

export const CambiarCaracteristica = (tipo, descripcion) => ({
  type: "EDIT_PAQUETE/CAMBIAR_CARACTERISTICA",
  tipo,
  descripcion,
});

export const CambiarTipoCaracteristica = (nuevaCaracteristica) => ({
  type: "CAMBIAR_TIPO_CATACTERISTICA",
  nuevaCaracteristica,
});

export const CambiarDescCaracteristica = (nuevaCaracteristicaDesc) => ({
  type: "CAMBIAR_DESC_CATACTERISTICA",
  nuevaCaracteristicaDesc,
});

export const CambiarPrestacionesSeleccionadas = (prestacionesSeleccionadasPQ) => ({
  type: "CAMBIAR_PRES_SELECCIONADAS",
  prestacionesSeleccionadasPQ,
});


export const openModalCaracteristicas = (estado) => ({
  type: "ABRIR_MODAL_ADD_CARACTERISTICAS",
  estado,
});

export const openModalDetallePrestacion = (estado) => ({
  type: "ABRIR_MODAL_DETALLE",
  estado,
});

export const openModalNuevaPrestacion = (estado) => ({
  type: "ABRIR_MODAL_NUEVA_PRESTACION",
  estado,
});

export const showErrorTipo = (errorCaract) => ({
  type: "DISPLAY_ERROR_TIPO",
  errorCaract,
});

export const showErrorDesc = (errorDesc) => ({
  type: "DISPLAY_ERROR_DESC",
  errorDesc,
});

export const showErrorPres = (errorPres) => ({
  type: "DISPLAY_ERROR_PRES",
  errorPres,
});



// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const ObtenerDetallePrestacionEdicion = (idPrestacion, isapre, callback) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    IdPrestacion: idPrestacion,
    Isapre: isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/prestaciones/detalle/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("ObtenerDetallePrestacionEdicion", result);
    dispatch(CargarDetallePrestacion(result));
    dispatch(callback());
  }), (error) => {
    trace.error("ObtenerDetallePrestacionEdicion", error);
    // dispatch(errorObtenerDetallePrestacionEdicion(error));
  });
};

export const ObtenerCentrosAtencionPorPrestacion = (idPrestacion, CodigoPrestacion, pCodProf, pTipoAtencion, pRutArancel, pRutInstitucion, isapre, next) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    IdPrestacion: idPrestacion,
    CodPrestacion: CodigoPrestacion,
    RutInstitucion: pRutInstitucion,
    RutArancel: pRutArancel,
    TipoAtencion: pTipoAtencion,
    CodProf: pCodProf,
    Isapre: isapre,
    token: globalState.token,
  };
  dispatch(LoadingArbolDetalle(true));
  fetch(`${apiConfig.apiUri}/v1/centroatencion/prestacion/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((res) => res.json().then((result) => {
      //trace.information("ObtenerCentrosAtencionPorPrestacion", result);
      dispatch(LoadingArbolDetalle(false));

      // Sort prests
      let rutArancelFirst = result.filter(e => e.IdPrestacion === idPrestacion)[0].RutArancel;
      let firstArancel = result.filter(e => e.RutArancel === rutArancelFirst);
      let aranceles = result.filter(e => e.RutArancel !== rutArancelFirst);
      let indexPrest = 0;
      let selectedPrest = {}

      for (const e of firstArancel) {
        if (e.IdPrestacion === idPrestacion) {
          indexPrest = firstArancel.indexOf(e);
          selectedPrest = e;
          break;
        }
      }

      firstArancel.splice(indexPrest, 1);
      firstArancel.unshift(selectedPrest);
      result = firstArancel.concat(aranceles);

      dispatch(CargarCentrosAtencionPrestacion(result));
      const editarPrestacionFormAux = store.getState().editarPrestacionForm;
      const filtrosBusqueda = store.getState().global.filtros_CAT;
      dispatch(GuardarArbolInicialMod(editarPrestacionFormAux.tiposArancelPrestacion, editarPrestacionFormAux.centrosAtencionPrestacion));
      dispatch(CambiarCheckRowsMod(true, idPrestacion, filtrosBusqueda.tipoArancel, filtrosBusqueda.centroAtencion));
      next()
    }))
    .catch((error) => {
      trace.error("ObtenerCentrosAtencionPorPrestacion", error);
      // dispatch(errorObtenerDetallePrestacionEdicion(error));
    });
};

export const obtenerValorMaxPrestacion = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/ValorMaxPrestacion/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerValorMaxPrestacion", json);
        dispatch(cargarValorMaxPrestacion(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerValorMaxPrestacion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener el valor máximo de la prestación:",
        error,
      ));
    });
};

